<template>
    <div class="col-sm-12 nopads">
        <div class="search-form p-2">
            <div class="col-sm-12 search-form-title">
                <font-awesome-icon icon="search"/>
                {{ $t('common.search') }}
            </div>
                <div class="row">
                    <div class="col-sm-6">
                        <open-contract-filter
                            :from="fromDate"
                            :to="toDate"
                            :contract="contract"
                            :apply-padding="false"
                            :row-view="false"
                            :showOnlyMyContractsOption="true"
                            :show-title="true"
                            :show-company="false"
                            @contractSelected="setContract"/>
                    </div>
                    <div class="col-sm-6">
                        <contract-order-multiselect
                            ref="orderFilter"
                            :contract-ids="contract ?  [contract.id] : []"
                            :single-mode="true"
                            @orders-selected="setOrder"
                        />
                    </div>
                </div>
                <div class="row px-1">
                    <div class="col-sm-6" style="padding-left: 1.1em; padding-right: 1.2em">
                        <span class="span-title">{{ $t('delivery_note.date') }} - {{ $t('trip_list.road_sec_from') }}</span>
                        <date-time-picker
                            v-model:date="fromDate"
                            format="dd.MM.yyyy HH:mm"
                            :enableTimePicker="true"
                            :placeholder="$t('observations_videos.search_input_format')"
                        />
                    </div>
                    <div class="col-sm-6">
                        <span class="span-title">{{ $t('delivery_note.date') }} - {{ $t('trip_list.road_sec_to') }}</span>
                        <date-time-picker
                            v-model:date="toDate"
                            format="dd.MM.yyyy HH:mm"
                            :enableTimePicker="true"
                            :placeholder="$t('observations_videos.search_input_format')"
                        />
                    </div>
                </div>
                <div class="col-12 text-end mt-3">
                    <button class="btn btn-danger form-button" @click.stop="onReset">
                        {{ $t('delivery_note.clear') }}
                    </button>
                    <button class="btn btn-primary form-button" @click.stop="onSubmit">
                        {{ $t('common.search') }}
                    </button>
                </div>
        </div>
        <div
            v-if="!!loading"
            id="loader"
            class="spinner"
        />
    </div>
</template>

<script>
import {restApi} from "@/components/mixins/RestApiMixin";
import {timeUtils} from "@/components/mixins/TimeUtils";
import {orderMixin} from "@/components/mixins/OrderMixin";
import OpenContractFilter from "@/components/contract/OpenContractFilter";
import DateTimePicker from "@/components/common/DateTimePicker";
import ContractOrderMultiselect from "../order/ContractOrderMultiselect.vue";

export default {
    name: "DispatchSearch",
    components: {ContractOrderMultiselect, DateTimePicker, OpenContractFilter},
    mixins: [restApi, timeUtils, orderMixin],
    data: function () {
        return {
            fromDate: this.loginTime ? this.loginTime.toISOString() : null,
            toDate: null,
            contract: null,
            order: null,
            loading: 0,
        }
    },
    mounted() {
        if (!this.fromDate) {
            this.fromDate = this.getMonthStart()
        }
    },
    methods: {
        setOrder(order) {
            this.order = order
        },

        setContract: function (contract) {
            this.contract = contract ? contract : null
        },

        refreshParams: function() {
            this.onSubmit()
        },

        onSubmit: function () {
            let params = {}
            if (this.fromDate !== null && this.fromDate.trim()) {
                params.timeFrom = new Date(this.fromDate).getTime()
            }
            if (this.toDate !== null && this.toDate.trim()) {
                params.timeTo = new Date(this.toDate).getTime()
            }
            if (this.contract !== null) {
                params.contract = this.contract.id
            }
            if (this.order) {
                params.order = this.order.id
            }
            this.$emit('search', params)
        },

        onReset: function () {
            this.fromDate = null
            this.toDate = null
            this.contract = null
            this.order = null
        }
    }
}
</script>
